<template>
  <!-- 积分商城 -->
  <div
    class="welfare"
    :class="
      isLoad &&
      scoreShopList[activeName] &&
      scoreShopList[activeName].length == 0
        ? ''
        : 'noList'
    "
    style="padding: 0.49rem 0 0.5rem 0; height: 100%"
  >
    <div class="welfare_title" v-show="this.scoreType.length > 0">
      <van-tabs
        v-model="activeName"
        color="#93683D"
        :swipeable="true"
        :sticky="true"
        offset-top="0.49rem"
      >
        <van-dropdown-menu
          active-color="#1989fa"
          style="
            padding: 0.05rem 0px;
            position: fixed;
            width: 100%;
            background-color: #ffffff;
          "
        >
          <van-dropdown-item
            @change="changeOrder"
            v-model="value"
            :options="option"
          />
        </van-dropdown-menu>
        <van-tab
          class="welfare_content"
          v-for="(type, index) in scoreType"
          :title="type.title"
          :name="type.title"
          :key="index"
        >
          <van-list
            class="vanlist"
            v-model="loading[index]"
            :finished="finished[index]"
            @load="onLoad(type.title, index)"
          >
            <div
              class="welfare_content_list"
              v-for="shop in scoreShopList[type.title]"
              :key="shop.id"
              @click="toRecordDetail(shop.id)"
            >
              <img
                :src="shop.pic"
                alt=""
                style="width: 1.65rem; height: 1.65rem"
              />
              <div style="padding: 0 0.1rem">
                <h2
                  style="
                    font-size: 0.13rem;
                    color: #333333;
                    margin-top: 0.07rem;
                  "
                >
                  {{ shop.title ? shop.title : "--" }}
                </h2>
                <p
                  style="
                    font-size: 0.14rem;
                    color: #333333;
                    margin-top: 0.06rem;
                  "
                >
                  <span style="color: #f12727">{{
                    shop.price ? shop.price : "-"
                  }}</span>
                  积分
                </p>
                <p
                  style="
                    font-size: 0.12rem;
                    color: #999a9c;
                    margin-top: 0.07rem;
                  "
                >
                  已兑{{ shop.buys ? shop.buys : "0" }}件
                </p>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
    <p
      v-if="
        isLoad &&
        scoreShopList[activeName] &&
        scoreShopList[activeName].length == 0
      "
      style="
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 1rem;
        font-size: 0.12rem;
        color: #99999b;
      "
    >
      <img
        style="width: 2.17rem; height: 1.54rem"
        src="../../assets/img/empty/img_blank_content@2x.png"
        alt=""
      />
      <span>暂无内容</span>
    </p>

    <!-- 底部的tab切换 -->
    <div class="tabbar">
      <van-tabbar
        v-model="active"
        inactive-color="#333333"
        active-color="#93683D"
      >
        <van-tabbar-item to="/welfare">
          <span>积分商城</span>
          <template #icon="props">
            <img :src="props.active ? icon.active1 : icon.inactive1" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/forRecord">
          <span>兑换记录</span>
          <template #icon="props">
            <img :src="props.active ? icon.active2 : icon.inactive2" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/integralWater">
          <span>积分流水</span>
          <template #icon="props">
            <img :src="props.active ? icon.active3 : icon.inactive3" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { getWelfareList } from '../../api/home'
export default {
  data () {
    return {
      isLoad: false,
      activeName: '全部',
      active: 0,
      page: [],
      newstypeList: [],
      loading: [],
      finished: [],
      scoreType: [],
      scoreShopList: [],
      value: 0,
      option: [
        { text: '默认排序', value: 0 },
        { text: '价格升序', value: 1 },
        { text: '价格降序', value: 2 },
        { text: '销量升序', value: 3 },
        { text: '销量降序', value: 4 }
      ],
      icon: {
        active1: require('../../assets/img/welfare/mall_btn_home_pre@2x.png'),
        inactive1: require('../../assets/img/welfare/mall_btn_home@2x.png'),
        active2: require('../../assets/img/welfare/mall_btn_record_pre@2x.png'),
        inactive2: require('../../assets/img/welfare/mall_btn_record@2x.png'),
        active3: require('../../assets/img/welfare/mall_btn_bill_pre@2x.png'),
        inactive3: require('../../assets/img/welfare/mall_btn_bill@2x.png')
      }
    }
  },
  created () {
    getWelfareList()
      .then((res) => {
        this.scoreType = res.data.backdata.score_type
        this.scoreType.unshift({ ctime: '0', id: '0', title: '全部' })
        for (let i = 0; i < this.scoreType.length; i++) {
          this.page.push(1)
          this.loading.push(false)
          this.finished.push(false)
          if (i >= 1) {
            this.onLoad(this.scoreType[i].title, i)
          }
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    changeOrder () {
      for (let i = 0; i < this.scoreType.length; i++) {
        this.page.push(1)
        this.loading.push(false)
        this.finished.push(false)
        this.onLoad(this.scoreType[i].title, i)
      }
    },
    onLoad (val, index) {
      getWelfareList({
        type_id: index,
        order: this.value,
        page: this.page[index]
      })
        .then((res) => {
          this.page[index] += 1
          this.loading[index] = false
          if (this.scoreShopList[val]) {
            // this.scoreShopList[val].push(...res.data.backdata.lists);
            const arr = [
              ...this.scoreShopList[val],
              ...res.data.backdata.lists
            ]
            this.$set(this.scoreShopList, val, arr)
          } else {
            // this.scoreShopList[val] = res.data.backdata.lists;
            this.$set(this.scoreShopList, val, res.data.backdata.lists)
          }
          if (this.scoreShopList[val].length >= res.data.ext.total) {
            this.finished[index] = true
          }
          this.isLoad = true
        })
        .catch((err) => {
          this.isLoad = true
          console.log(err)
        })
    },
    // 点击跳往兑换详情页面
    toRecordDetail (id) {
      this.$router.push({
        name: '积分兑换商品详情',
        params: {
          score_id: id
        }
      })
    }
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background:#ffffff')
  },
  beforeDestroy () {
    document.querySelector('body').setAttribute('style', 'background:#f3f1f4')
  }
}
</script>

<style lang='scss'>
.noList {
  // background-image: none !important;
  background-color: #ffffff !important;
}
.welfare {
  padding-bottom: 0.49rem;
  .tabbar {
    height: 0.49rem;
    .van-tabbar {
      height: 0.49rem;
      .van-tabbar-item {
        img {
          width: 0.22rem;
          height: 0.22rem;
        }
        span {
          display: block;
          transform: scale(0.8);
          font-size: 0.125rem;
        }
      }
    }
  }
  // background: url("../../assets/img/empty/img_blank_content@2x.png") no-repeat
  //   center center;
  // background-size: 2.17rem 1.54rem;
  background-color: #f3f1f4;
  .vanlist {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-top: 0.22rem;
    justify-content: space-between;
    .van-list__loading {
      width: 100%;
    }
  }
  .van-dropdown-menu__bar {
    height: 0.3rem;
    box-shadow: none;
    // margin-top: 0.06rem;
    .van-dropdown-menu__item {
      justify-content: flex-start !important;
      padding: 0 0.1rem;
      .van-dropdown-menu__title {
        font-size: 0.12rem;
        color: #0b0606;
      }
    }
  }
  .welfare_title {
    // position: fixed;
    width: 100%;
    // background: #ffffff;
    // tab切换
    .van-tab {
      color: #333333;
      font-size: 0.14rem;
      line-height: 0.2rem;
    }
    .van-tab--active {
      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
    }
    .welfare_order {
      height: 0.4rem;
      width: 0.8rem;
      line-height: 0.4rem;
      padding-left: 0.16rem;
      font-size: 0.12rem;
      color: #0b0606;
      display: flex;
      align-items: center;
    }
  }
  .welfare_content {
    padding: 0 0.16rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .welfare_content_list {
      width: 1.65rem;
      height: 2.42rem;
      margin-bottom: 0.11rem;
    }
  }
  // 下拉列表的颜色
  .van-dropdown-menu__title--active {
    color: #93683d !important;
  }
  .van-dropdown-item__option--active {
    color: #93683d !important;
  }
  .van-dropdown-item__option--active {
    color: #93683d !important;
    .van-dropdown-item__icon {
      color: #93683d !important;
    }
  }
  .tabbar {
    height: 0.49rem;
    .van-tabbar {
      height: 0.49rem;
      .van-tabbar-item {
        img {
          width: 0.22rem;
          height: 0.22rem;
        }
        span {
          display: block;
          transform: scale(0.8);
          font-size: 0.125rem;
        }
      }
    }
  }
}
</style>
